<template>
    <div class="quiz-summary">
        <div class="quiz-summary__background">
            <img src="~@/assets/images/quiz-bgc.png" alt="kasanowa" />
        </div>
        <KLayoutWrapper>
            <template #default>
                <div>
                    <div class="quiz-summary__admin-title">{{ $t('quiz.quiz') }}</div>
                    <div class="quiz-summary__description">
                        <div>{{ $t('quiz.quizDescription1') }}</div>
                        <span>{{ $t('quiz.quizDescription2') }}</span>
                    </div>

                    <div class="quiz-summary__main-details-wrapper">
                        <div class="quiz-summary__item-wrapper quiz-summary__item-wrapper--first">
                            <div class="quiz-summary__item quiz-summary__item--first kasanowa-bold">{{ $t('quiz.nameForm') }}</div>
                            <div class="quiz-summary__item quiz-summary__item--second">
                                <div v-if="!summaryForm.isTitleEditMode">{{ summaryForm.title }}</div>
                                <KTextField
                                    v-if="summaryForm.isTitleEditMode"
                                    id="input-title"
                                    v-model="summaryForm.title"
                                    name="title"
                                    label=""
                                    hide-details
                                    :placeholder="$t('quiz.nameForm')"
                                />
                            </div>
                            <div v-if="!summaryForm.isTitleEditMode" class="quiz-summary__item quiz-summary__item--third">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemEditMode('title')">
                                    <KIcon icon="edit" width="18" height="18" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemRemoveTitle('title')">
                                    <KIcon icon="trash" width="18" height="18" />
                                </div>
                            </div>
                            <div v-if="summaryForm.isTitleEditMode" class="quiz-summary__item quiz-summary__item--third">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemAcceptChange('title')">
                                    <KIcon icon="tick" width="20" height="20" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemCancelChange('title')">
                                    <KIcon icon="close" width="20" height="20" />
                                </div>
                            </div>
                        </div>

                        <div class="quiz-summary__item-wrapper">
                            <div class="quiz-summary__item quiz-summary__item--first kasanowa-bold">{{ $t('quiz.leadForm') }}</div>
                            <div class="quiz-summary__item quiz-summary__item--second quiz-summary__item--white">
                                <div v-if="!summaryForm.isLeadEditMode">{{ summaryForm.lead }}</div>
                                <KTextField
                                    v-if="summaryForm.isLeadEditMode"
                                    id="input-lead"
                                    v-model="summaryForm.lead"
                                    name="lead"
                                    label=""
                                    hide-details
                                    :placeholder="$t('quiz.leadForm')"
                                />
                            </div>
                            <div v-if="!summaryForm.isLeadEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemEditMode('lead')">
                                    <KIcon icon="edit" width="18" height="18" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemRemoveTitle('lead')">
                                    <KIcon icon="trash" width="18" height="18" :color="black" />
                                </div>
                            </div>
                            <div v-if="summaryForm.isLeadEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemAcceptChange('lead')">
                                    <KIcon icon="tick" width="20" height="20" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemCancelChange('lead')">
                                    <KIcon icon="close" width="20" height="20" :color="black" />
                                </div>
                            </div>
                        </div>

                        <div class="quiz-summary__item-wrapper">
                            <div class="quiz-summary__item quiz-summary__item--first kasanowa-bold">{{ $t('quiz.textForm') }}</div>
                            <div class="quiz-summary__item quiz-summary__item--second quiz-summary__item--white">
                                <div v-if="!summaryForm.isTextEditMode">{{ summaryForm.text }}</div>
                                <KTextArea
                                    v-if="summaryForm.isTextEditMode"
                                    id="input-text"
                                    v-model="summaryForm.text"
                                    name="text"
                                    label=""
                                    hide-details
                                    :placeholder="$t('quiz.textForm')"
                                />
                            </div>
                            <div v-if="!summaryForm.isTextEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemEditMode('text')">
                                    <KIcon icon="edit" width="18" height="18" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemRemoveTitle('text')">
                                    <KIcon icon="trash" width="18" height="18" :color="black" />
                                </div>
                            </div>
                            <div v-if="summaryForm.isTextEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemAcceptChange('text')">
                                    <KIcon icon="tick" width="20" height="20" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemCancelChange('text')">
                                    <KIcon icon="close" width="20" height="20" :color="black" />
                                </div>
                            </div>
                        </div>

                        <div class="quiz-summary__item-wrapper">
                            <div class="quiz-summary__item quiz-summary__item--first kasanowa-bold">{{ $t('quiz.dateFromForm') }}</div>
                            <div class="quiz-summary__item quiz-summary__item--second quiz-summary__item--white">
                                <div v-if="!summaryForm.isDateFromEditMode">{{ null != summaryForm.dateFrom ? useDataFormat(summaryForm.dateFrom) : '' }}</div>
                                <KDatePicker
                                    v-if="summaryForm.isDateFromEditMode"
                                    id="input-date-from"
                                    v-model="summaryForm.dateFrom"
                                    name="dateFrom"
                                    min-view="day"
                                    max-view="year"
                                    hide-errors
                                    :placeholder="$t('quiz.dateFromForm')"
                                />
                            </div>
                            <div v-if="!summaryForm.isDateFromEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemEditMode('dateFrom')">
                                    <KIcon icon="edit" width="18" height="18" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemRemoveTitle('dateFrom')">
                                    <KIcon icon="trash" width="18" height="18" :color="black" />
                                </div>
                            </div>
                            <div v-if="summaryForm.isDateFromEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemAcceptChange('dateFrom')">
                                    <KIcon icon="tick" width="20" height="20" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemCancelChange('dateFrom')">
                                    <KIcon icon="close" width="20" height="20" :color="black" />
                                </div>
                            </div>
                        </div>

                        <div class="quiz-summary__item-wrapper">
                            <div class="quiz-summary__item quiz-summary__item--first kasanowa-bold">{{ $t('quiz.dateToForm') }}</div>
                            <div class="quiz-summary__item quiz-summary__item--second quiz-summary__item--white">
                                <div v-if="!summaryForm.isDateToEditMode">{{ null != summaryForm.dateTo ? useDataFormat(summaryForm.dateTo) : '' }}</div>
                                <KDatePicker
                                    v-if="summaryForm.isDateToEditMode"
                                    id="input-date-to"
                                    v-model="summaryForm.dateTo"
                                    name="dateTo"
                                    min-view="day"
                                    max-view="year"
                                    hide-errors
                                    :placeholder="$t('quiz.dateToForm')"
                                />
                            </div>
                            <div v-if="!summaryForm.isDateToEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemEditMode('dateTo')">
                                    <KIcon icon="edit" width="18" height="18" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemRemoveTitle('dateTo')">
                                    <KIcon icon="trash" width="18" height="18" :color="black" />
                                </div>
                            </div>
                            <div v-if="summaryForm.isDateToEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemAcceptChange('dateTo')">
                                    <KIcon icon="tick" width="20" height="20" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemCancelChange('dateTo')">
                                    <KIcon icon="close" width="20" height="20" :color="black" />
                                </div>
                            </div>
                        </div>

                        <div class="quiz-summary__item-wrapper">
                            <div class="quiz-summary__item quiz-summary__item--first kasanowa-bold">{{ $t('quiz.imageForm') }}</div>
                            <div class="quiz-summary__item quiz-summary__item--second quiz-summary__item--white">
                                <div v-if="!summaryForm.isImageEditMode">{{ typeof summaryForm.image === 'object' && summaryForm.image?.name ? summaryForm.image.name : '' }}</div>
                                <img v-if="!summaryForm.isImageEditMode && typeof summaryForm.image === 'string'" :src="summaryForm.image" alt="kasanowa-quiz-image" />
                                <DragAndDropFile
                                    v-if="summaryForm.isImageEditMode"
                                    input-id="drop-image"
                                    acceptance=".png,.jpg,.jpeg"
                                    :on-files-change="onFilesChange"
                                />
                            </div>
                            <div v-if="!summaryForm.isImageEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemEditMode('image')">
                                    <KIcon icon="edit" width="18" height="18" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemRemoveTitle('image')">
                                    <KIcon icon="trash" width="18" height="18" :color="black" />
                                </div>
                            </div>
                            <div v-if="summaryForm.isImageEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemAcceptChange('image')">
                                    <KIcon icon="tick" width="20" height="20" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemCancelChange('image')">
                                    <KIcon icon="close" width="20" height="20" :color="black" />
                                </div>
                            </div>
                        </div>

                        <div class="quiz-summary__item-wrapper">
                            <div class="quiz-summary__item quiz-summary__item--first kasanowa-bold">{{ $t('quiz.videoForm') }}</div>
                            <div class="quiz-summary__item quiz-summary__item--second quiz-summary__item--white">
                                <div v-if="!summaryForm.isVideoEditMode">{{ summaryForm.video }}</div>
                                <KTextField
                                    v-if="summaryForm.isVideoEditMode"
                                    id="input-video"
                                    v-model="summaryForm.video"
                                    name="video"
                                    label=""
                                    hide-details
                                    :placeholder="$t('quiz.videoForm')"
                                />
                            </div>
                            <div v-if="!summaryForm.isVideoEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemEditMode('video')">
                                    <KIcon icon="edit" width="18" height="18" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemRemoveTitle('video')">
                                    <KIcon icon="trash" width="18" height="18" :color="black" />
                                </div>
                            </div>
                            <div v-if="summaryForm.isVideoEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemAcceptChange('video')">
                                    <KIcon icon="tick" width="20" height="20" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemCancelChange('video')">
                                    <KIcon icon="close" width="20" height="20" :color="black" />
                                </div>
                            </div>
                        </div>

                        <div class="quiz-summary__item-wrapper">
                            <div class="quiz-summary__item quiz-summary__item--first kasanowa-bold">{{ $t('quiz.manyTimes') }}</div>
                            <div class="quiz-summary__item quiz-summary__item--second quiz-summary__item--white">
                                <div class="quiz-summary__item-checkbox-wrapper">
                                    <KCheckbox
                                        id="type-one-time"
                                        v-model="summaryForm.isOneTime"
                                        :label="$t('quiz.yes')"
                                        hide-details
                                        @click="handleCheckboxClick(true)"
                                    />
                                    <KCheckbox
                                        id="type-many-time"
                                        v-model="summaryForm.isManyTimes"
                                        :label="$t('quiz.no')"
                                        hide-details
                                        @click="handleCheckboxClick(false)"
                                    />
                                </div>
                            </div>
                            <div class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white"></div>
                        </div>

                        <div class="quiz-summary__item-wrapper">
                            <div class="quiz-summary__item quiz-summary__item--first kasanowa-bold">{{ $t('quiz.priceForm') }}</div>
                            <div class="quiz-summary__item quiz-summary__item--second quiz-summary__item--white">
                                <div v-if="!summaryForm.isPriceEditMode">{{ summaryForm.price }}</div>
                                <KTextField
                                    v-if="summaryForm.isPriceEditMode"
                                    id="input-price"
                                    v-model="summaryForm.price"
                                    name="price"
                                    label=""
                                    hide-details
                                    :placeholder="$t('quiz.priceForm')"
                                    type="number"
                                    min="0"
                                />
                            </div>
                            <div v-if="!summaryForm.isPriceEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemEditMode('price')">
                                    <KIcon icon="edit" width="18" height="18" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemRemoveTitle('price')">
                                    <KIcon icon="trash" width="18" height="18" :color="black" />
                                </div>
                            </div>
                            <div v-if="summaryForm.isPriceEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemAcceptChange('price')">
                                    <KIcon icon="tick" width="20" height="20" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemCancelChange('price')">
                                    <KIcon icon="close" width="20" height="20" :color="black" />
                                </div>
                            </div>
                        </div>

                        <div class="quiz-summary__item-wrapper">
                            <div class="quiz-summary__item quiz-summary__item--first kasanowa-bold">{{ $t('quiz.surveyForm') }}</div>
                            <div class="quiz-summary__item quiz-summary__item--second quiz-summary__item--white">
                                <div class="quiz-summary__item-checkbox-wrapper">
                                    <KCheckbox
                                        id="is-survey"
                                        v-model="summaryForm.isSurvey"
                                        :label="$t('quiz.yes')"
                                        hide-details
                                        @click="handleSurveyCheckboxClick(true)"
                                    />
                                    <KCheckbox
                                        id="type-not-survey"
                                        v-model="summaryForm.isNotSurvey"
                                        :label="$t('quiz.no')"
                                        hide-details
                                        @click="handleSurveyCheckboxClick(false)"
                                    />
                                </div>
                            </div>
                            <div class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white"></div>
                        </div>

                        <div class="quiz-summary__item-wrapper">
                            <div class="quiz-summary__item quiz-summary__item--first kasanowa-bold">{{ $t('quiz.correctAnswersForm') }}</div>
                            <div class="quiz-summary__item quiz-summary__item--second quiz-summary__item--white">
                                <div v-if="!summaryForm.isCorrectAnswersEditMode">{{ summaryForm.correctAnswers }}</div>
                                <KTextField
                                    v-if="summaryForm.isCorrectAnswersEditMode"
                                    id="input-correct-answers"
                                    v-model="summaryForm.correctAnswers"
                                    name="correctAnswers"
                                    label=""
                                    hide-details
                                    :placeholder="$t('quiz.correctAnswersForm')"
                                    type="number"
                                    step="1"
                                    min="0"
                                />
                            </div>
                            <div v-if="!summaryForm.isCorrectAnswersEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemEditMode('correctAnswers')">
                                    <KIcon icon="edit" width="18" height="18" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemRemoveTitle('correctAnswers')">
                                    <KIcon icon="trash" width="18" height="18" :color="black" />
                                </div>
                            </div>
                            <div v-if="summaryForm.isCorrectAnswersEditMode" class="quiz-summary__item quiz-summary__item--third quiz-summary__item--white">
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemAcceptChange('correctAnswers')">
                                    <KIcon icon="tick" width="20" height="20" :color="black" />
                                </div>
                                <div class="quiz-summary__item-icon kasanowa-hover" @click="handleItemCancelChange('correctAnswers')">
                                    <KIcon icon="close" width="20" height="20" :color="black" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="quiz-summary__submit-btn-wrapper">
                        <KButton
                            id="submit-btn"
                            :label="$t('quiz.saveSummary')"
                            icon="arrowRight"
                            :color="black"
                            width="11"
                            height="11"
                            uppercase
                            secondary
                            type="submit"
                            @click="onSubmit"
                            :disabled="loading"
                        />
                    </div>
                </div>
            </template>
        </KLayoutWrapper>
    </div>
</template>

<script setup lang="ts">
import { ref } from '@vue/runtime-core';
import router from '@/router';
import QuizApi from '@/api/v1/QuizApi';
import { toast } from 'vue3-toastify';
import { navigateToWithErrorToast, navigateToWithSuccessToast } from '@/hooks/NavigateHooks';
import { useDataFormat } from '@/hooks/DataHooks';
import variables from '@/assets/scss/modules/variables.module.scss';
import type { IQuizSummary } from '@/models/QuizModel';
import type { IProductList } from '@/models/ProductsModel';
import KLayoutWrapper from '@/components/atoms/KLayoutWrapper.vue';
import KTextField from '@/components/atoms/KTextField.vue';
import KIcon from '@/components/atoms/KIcon.vue';
import DragAndDropFile from '@/components/molecules/DragAndDropFile.vue';
import KTextArea from '@/components/atoms/KTextArea.vue';
import KDatePicker from '@/components/atoms/KDatePicker.vue';
import KButton from '@/components/atoms/KButton.vue';
import KCheckbox from '@/components/atoms/KCheckbox.vue';

const { black } = variables;

const summaryForm = ref<IQuizSummary>({
    id: null,
    title: null,
    prevTitle: null,
    lead: null,
    prevLead: null,
    text: null,
    prevText: null,
    video: null,
    prevVideo: null,
    price: null,
    prevPrice: null,
    correctAnswers: null,
    prevCorrectAnswers: null,
    dateFrom: null,
    prevDateFrom: null,
    dateTo: null,
    prevDateTo: null,
    image: null,
    prevImage: null,
    isTitleEditMode: false,
    isLeadEditMode: false,
    isTextEditMode: false,
    isImageEditMode: false,
    isDateFromEditMode: false,
    isDateToEditMode: false,
    isPriceEditMode: false,
    isCorrectAnswersEditMode: false,
    isVideoEditMode: false,
    questions: [],
    isOneTime: true,
    isManyTimes: false,
    isSurvey: false,
    isNotSurvey: true,
});

const loading = ref<boolean>(false);
const quizApi = new QuizApi();
const quizDetails = async() => {
    loading.value = true;
    try {
        const result = await quizApi.quizDetails(router.currentRoute.value.params.id);
        if (!result.isSuccess) {
            navigateToWithErrorToast(`/quiz/${router.currentRoute.value.params.id}`, t('quiz.toast.errorQuizDetails'));
            loading.value = false;
            return;
        }
        summaryForm.value = {
            id: result.payload.id,
            title: result.payload.name,
            prevTitle: result.payload.name,
            lead: result.payload.lead,
            prevLead: result.payload.lead,
            text: result.payload.text,
            prevText: result.payload.text,
            video: result.payload.video_url,
            prevVideo: result.payload.video_url,
            price: result.payload.value,
            prevPrice: result.payload.value,
            correctAnswers: result.payload.correct_answers,
            prevCorrectAnswers: result.payload.correct_answers,
            dateFrom: result.payload.start_at,
            prevDateFrom: result.payload.start_at,
            dateTo: result.payload.end_at,
            prevDateTo: result.payload.end_at,
            image: result.payload.image,
            prevImage: result.payload.image,
            isTitleEditMode: false,
            isLeadEditMode: false,
            isTextEditMode: false,
            isImageEditMode: false,
            isDateFromEditMode: true,
            isDateToEditMode: true,
            isPriceEditMode: true,
            isCorrectAnswersEditMode: false,
            isVideoEditMode: false,
            questions: result.payload.questions,
            isOneTime: result.payload.is_one_time,
            isManyTimes: !result.payload.is_one_time,
            isSurvey: result.payload.is_questionnaire,
            isNotSurvey: !result.payload.is_questionnaire,
        };
    } catch (e) {
        navigateToWithErrorToast(`/quiz/${router.currentRoute.value.params.id}`, t('quiz.toast.errorQuizDetails'));
        loading.value = false;
        return;
    }
    loading.value = false;
};
quizDetails();

const handleItemEditMode = (slug: string) => {
    switch (slug) {
        case 'title':
            summaryForm.value.isTitleEditMode = true;
            break;
        case 'lead':
            summaryForm.value.isLeadEditMode = true;
            break;
        case 'text':
            summaryForm.value.isTextEditMode = true;
            break;
        case 'image':
            summaryForm.value.isImageEditMode = true;
            break;
        case 'dateFrom':
            summaryForm.value.isDateFromEditMode = true;
            break;
        case 'dateTo':
            summaryForm.value.isDateToEditMode = true;
            break;
        case 'price':
            summaryForm.value.isPriceEditMode = true;
            break;
        case 'correctAnswers':
            summaryForm.value.isCorrectAnswersEditMode = true;
            break;
        case 'video':
            summaryForm.value.isVideoEditMode = true;
            break;
        default:
            summaryForm.value.isTitleEditMode = true;
    }
};
const handleItemAcceptChange = (slug: string) => {
    switch (slug) {
        case 'title':
            summaryForm.value.isTitleEditMode = false;
            summaryForm.value.prevTitle = summaryForm.value.title;
            break;
        case 'lead':
            summaryForm.value.isLeadEditMode = false;
            summaryForm.value.prevLead = summaryForm.value.lead;
            break;
        case 'text':
            summaryForm.value.isTextEditMode = false;
            summaryForm.value.prevText = summaryForm.value.text;
            break;
        case 'image':
            summaryForm.value.isImageEditMode = false;
            summaryForm.value.prevImage = summaryForm.value.image;
            break;
        case 'dateFrom':
            summaryForm.value.isDateFromEditMode = false;
            summaryForm.value.prevDateFrom = summaryForm.value.dateFrom;
            break;
        case 'dateTo':
            summaryForm.value.isDateToEditMode = false;
            summaryForm.value.prevDateTo = summaryForm.value.dateTo;
            break;
        case 'price':
            summaryForm.value.isPriceEditMode = false;
            summaryForm.value.prevPrice = summaryForm.value.price;
            break;
        case 'correctAnswers':
            summaryForm.value.isCorrectAnswersEditMode = false;
            summaryForm.value.prevCorrectAnswers = summaryForm.value.correctAnswers;
            break;
        case 'video':
            summaryForm.value.isVideoEditMode = false;
            summaryForm.value.prevVideo = summaryForm.value.video;
            break;
        default:
            summaryForm.value.isTitleEditMode = false;
            summaryForm.value.prevTitle = summaryForm.value.title;
    }
};
const handleItemCancelChange = (slug: string) => {
    switch (slug) {
        case 'title':
            summaryForm.value.isTitleEditMode = false;
            summaryForm.value.title = summaryForm.value.prevTitle;
            break;
        case 'lead':
            summaryForm.value.isLeadEditMode = false;
            summaryForm.value.lead = summaryForm.value.prevLead;
            break;
        case 'text':
            summaryForm.value.isTextEditMode = false;
            summaryForm.value.text = summaryForm.value.prevText;
            break;
        case 'image':
            summaryForm.value.isImageEditMode = false;
            summaryForm.value.image = summaryForm.value.prevImage;
            break;
        case 'dateFrom':
            summaryForm.value.isDateFromEditMode = false;
            summaryForm.value.dateFrom = summaryForm.value.prevDateFrom;
            break;
        case 'dateTo':
            summaryForm.value.isDateToEditMode = false;
            summaryForm.value.dateTo = summaryForm.value.prevDateTo;
            break;
        case 'price':
            summaryForm.value.isPriceEditMode = false;
            summaryForm.value.price = summaryForm.value.prevPrice;
            break;
        case 'correctAnswers':
            summaryForm.value.isCorrectAnswersEditMode = false;
            summaryForm.value.correctAnswers = summaryForm.value.prevCorrectAnswers;
            break;
        case 'video':
            summaryForm.value.isVideoEditMode = false;
            summaryForm.value.video = summaryForm.value.prevVideo;
            break;
        default:
            summaryForm.value.isTitleEditMode = false;
            summaryForm.value.title = summaryForm.value.prevTitle;
    }
};
const handleItemRemoveTitle = (slug: string) => {
    switch (slug) {
        case 'title':
            summaryForm.value.title = null;
            summaryForm.value.prevTitle = null;
            break;
        case 'lead':
            summaryForm.value.lead = null;
            summaryForm.value.prevLead = null;
            break;
        case 'text':
            summaryForm.value.text = null;
            summaryForm.value.prevText = null;
            break;
        case 'image':
            summaryForm.value.image = null;
            summaryForm.value.prevImage = null;
            break;
        case 'dateFrom':
            summaryForm.value.dateFrom = null;
            summaryForm.value.prevDateFrom = null;
            break;
        case 'dateTo':
            summaryForm.value.dateTo = null;
            summaryForm.value.prevDateTo = null;
            break;
        case 'price':
            summaryForm.value.price = null;
            summaryForm.value.prevPrice = null;
            break;
        case 'correctAnswers':
            summaryForm.value.correctAnswers = null;
            summaryForm.value.prevCorrectAnswers = null;
            break;
        case 'video':
            summaryForm.value.video = null;
            summaryForm.value.prevVideo = null;
            break;
        default:
            summaryForm.value.title = null;
            summaryForm.value.prevTitle = null;
    }
};
const onFilesChange = (files: File[]) => {
    if (null != files && files.length > 0) {
        summaryForm.value.image = files[0];
    } else {
        summaryForm.value.image = null;
    }
};

const onSubmit = async() => {
    loading.value = true;
    if (summaryForm.value.price == null) {
        loading.value = false;
        toast.error(t('quiz.toast.errorPriceValidation'));
        return;
    }
    if (summaryForm.value.dateFrom == null || summaryForm.value.dateTo == null) {
        loading.value = false;
        toast.error(t('quiz.toast.errorDateValidation'));
        return;
    }
    try {
        const result = await quizApi.saveQuizSummary(
            {
                name: summaryForm.value.title,
                lead: summaryForm.value.lead,
                text: summaryForm.value.text,
                image: summaryForm.value.image,
                video_url: summaryForm.value.video,
                date_from: summaryForm.value.dateFrom,
                date_to: summaryForm.value.dateTo,
                is_one_time: summaryForm.value.isOneTime,
                price: +summaryForm.value.price,
                is_survey: summaryForm.value.isSurvey,
                correct_answers: +summaryForm.value.correctAnswers,
            },
            router.currentRoute.value.params.id,
        );
        if (!result.isSuccess) {
            loading.value = false;
            toast.error(t('quiz.toast.errorEditQuiz'));
            return;
        }
        navigateToWithSuccessToast(`/quiz`, t('quiz.toast.successEditQuiz'));
    } catch (e) {
        loading.value = false;
        toast.error(t('quiz.toast.errorEditQuiz'));
        return;
    }
    loading.value = false;
};

const handleCheckboxClick = (isOneTime: boolean) => {
    setTimeout(() => {
        if (isOneTime) {
            summaryForm.value.isOneTime = true;
            summaryForm.value.isManyTimes = false;
        }
        if (!isOneTime) {
            summaryForm.value.isOneTime = false;
            summaryForm.value.isManyTimes = true;
        }
    }, 1);
};

const handleSurveyCheckboxClick = (isSurvey: boolean) => {
    setTimeout(() => {
        if (isSurvey) {
            summaryForm.value.isSurvey = true;
            summaryForm.value.isNotSurvey = false;
        }
        if (!isSurvey) {
            summaryForm.value.isSurvey = false;
            summaryForm.value.isNotSurvey = true;
        }
    }, 1);
};
</script>

<style scoped lang="scss">
.quiz-summary {
    width: 100%;
    position: relative;

    &__background {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        width: 100%;
        height: 100%;

        img {
            object-fit: cover;
            width: 100%;
            height: calc(100% - 184px);
            min-height: calc(100vh - 184px);

            @include media-breakpoint-up(lg) {
                height: calc(100% - 217px);
                min-height: calc(100vh - 217px);
            }
        }
    }

    &__admin-title {
        background-color: $primary-400;
        color: $black;
        font-weight: 1000;
        padding: 8px;
        text-transform: uppercase;
        font-size: 20px;
        text-align: center;
        max-width: 520px;
        margin: 0 auto;

        @include media-breakpoint-up(lg) {
            font-size: 40px;
            padding: 18px 24px;
            max-width: 680px;
        }
    }

    &__description {
        margin-top: 17px;
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        justify-content: center;
        color: $white;
        font-size: 18px;

        span {
            font-weight: 700;
            color: $primary-400;
        }
    }

    &__main-details-wrapper {
        display: flex;
        flex-direction: column;
        overflow-x: scroll;
        margin-top: 60px;

        @include media-breakpoint-up(xxl) {
            overflow-x: visible;
        }
    }

    &__item-wrapper {
        display: flex;
        width: 1272px;

        &--first {
            border-bottom: 3px solid $secondary-400;
        }
    }

    &__item {
        color: $white;
        padding: 15px 0;
        display: flex;
        background-color: $primary-800;

        &--first {
            padding-left: 20px;
            width: 20%;
            min-width: 220px;
            max-width: 220px;
        }

        &--second {
            width: 70%;
            min-width: 925px;
            padding: 15px 20px;
        }

        &--third {
            width: 10%;
            min-width: 120px;
            padding: 5px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 25px;
        }

        &--white {
            background-color: $white;
            color: $black;
        }

        &--align-left {
            justify-content: flex-start;
            padding-left: 10px;
        }

        &--score {
            width: 183px;
        }

        &:deep(.k-input) {
            background-color: $white;
            border-radius: 8px;
        }

        &:deep(.k-text-area) {
            background-color: $white;
            border-radius: 5px;
            width: 100%;
            border: 1px solid $grey-400;
        }

        &:deep(.drag-and-drop-file) {
            width: 100%;
        }

        &:deep(.vuejs3-datepicker__value) {
            background-color: $white;
        }

        &:deep(.k-autocomplete) {
            width: 100%;
        }

        &:deep(.k-select) {
            width: 300px;
            background-color: $white;
            border-radius: 5px;
        }
    }

    &__list-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 5px;
    }

    &__score-wrapper {
        display: flex;
        flex-direction: column;
        gap: 1px;

        &:deep(.k-input) {
            width: 50%;
        }
    }

    &__score {
        background-color: $black;
        width: 174px;
        height: 62px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__number {
        background-color: $black;
        width: 174px;
        height: 62px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }

    &__score-second-wrapper {
        justify-content: space-around;
        background-color: $black;
        width: 174px;
        height: 62px;
    }

    &__submit-btn-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
    }

    &__item-checkbox-wrapper {
        display: flex;
        gap: 15px;
    }
}
</style>
